import { render, staticRenderFns } from "./GlobalPublishing.vue?vue&type=template&id=69d150a7&scoped=true"
import script from "./GlobalPublishing.vue?vue&type=script&lang=js"
export * from "./GlobalPublishing.vue?vue&type=script&lang=js"
import style0 from "./GlobalPublishing.vue?vue&type=style&index=0&id=69d150a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d150a7",
  null
  
)

export default component.exports